import dayjs from "dayjs";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <span className="font-bold text-lg">ExpenseHut</span>
            </Link>
            <p className="text-slate-400 text-sm">
              Smart expense tracking for families and groups
            </p>
          </div>

          {/* Product */}
          <div>
            <h3 className="font-semibold mb-4">Product</h3>
            <ul className="space-y-2 text-slate-400 text-sm">
              <li>
                <a
                  href="https://app.expensehut.com"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-white transition"
                >
                  Features
                </a>
              </li>
              <li>
                <a
                  href="https://app.expensehut.com/#pricing"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-white transition"
                >
                  Pricing
                </a>
              </li>
              <li>
                <a
                  href="https://app.expensehut.com/#security"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-white transition"
                >
                  Security
                </a>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="font-semibold mb-4">Company</h3>
            <ul className="space-y-2 text-slate-400 text-sm">
              <li>
                <a
                  href="https://help.expensehut.com/about"
                  className="hover:text-white transition"
                  target="_blank"
                  rel="noreferrer"
                >
                  About
                </a>
              </li>
              <li>
                <a
                  href="https://help.expensehut.com/contactus"
                  className="hover:text-white transition"
                  target="_blank"
                  rel="noreferrer"
                >
                  Contact
                </a>
              </li>
              <li>
                <a
                  href="https://app.expensehut.com/refund-policy"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-white transition"
                >
                  Refund Policy
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-semibold mb-4">Legal</h3>
            <ul className="space-y-2 text-slate-400 text-sm">
              <li>
                <a
                  href="https://help.expensehut.com/contactus"
                  className="hover:text-white transition"
                  target="_blank"
                  rel="noreferrer"
                >
                  Contact
                </a>
              </li>
              <li>
                <a
                  href="https://app.expensehut.com/terms"
                  className="hover:text-white transition"
                  target="_blank"
                  rel="noreferrer"
                >
                  Terms
                </a>
              </li>
              <li>
                <a
                  href="https://help.expensehut.com/cookies"
                  className="hover:text-white transition"
                  target="_blank"
                  rel="noreferrer"
                >
                  Cookies
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center text-slate-400 text-sm">
          <p>&copy; {dayjs().year()} ExpenseHut. All rights reserved.</p>
          <div className="flex gap-6 mt-4 md:mt-0">
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.youtube.com/@expensehut"
              className="hover:text-white transition"
            >
              Youtube
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.instagram.com/expensehut"
              className="hover:text-white transition"
            >
              Instagram
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.facebook.com/people/Expensehut"
              className="hover:text-white transition"
            >
              Facebook
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
